import React from 'react'


const CircleMinus = (props) =>
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 24 24">
        <path d="M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-22C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11H7a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2z" fillRule="evenodd"/>
    </svg>

export default CircleMinus


// WEBPACK FOOTER //
// ./src/components/_common/_icons/CircleMinus.js